(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bikelane-ultimi-arrivi"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('bl-arrivi-tabs')) return;

    class BlArriviTabs extends HTMLElement {
      connectedCallback() {
        this.onClick = this.handleClick.bind(this);
        this.onBlockSelect = this.handleBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }
      handleClick(event) {
        var btn = event.target.closest('[role="tab"]');
        if (btn && this.contains(btn)) this.select(Number(btn.dataset.index));
      }
      handleBlockSelect(event) {
        if (this.contains(event.target) && event.target.matches('[role="tab"]')) {
          this.select(Number(event.target.dataset.index));
        }
      }
      select(index) {
        this.querySelectorAll('[role="tab"]').forEach(function (tab) {
          var active = Number(tab.dataset.index) === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
          panel.hidden = Number(panel.dataset.index) !== index;
        });
      }
    }

    customElements.define('bl-arrivi-tabs', BlArriviTabs);
  })();

  } catch(e) { console.error(e); }
})();
})();
